module.exports = __webpack_public_path__ + "static/img/11.b0d85036.gif";